<template>
<div>

  <vs-popup fullscreen :title="file.name" :active.sync="popupActivo">
    <div v-if="file.type === 'pdf' || file.type === 'xls' || file.type === 'xlsx'">
      <iframe :src="file.source" class="w-full show-pdf scroll-hiden" :style="{ height:100+'vh' }"></iframe>
    </div>
    <div v-if="file.type === 'png' || file.type === 'jpg' || file.type === 'jpeg'">
      <vue-perfect-scrollbar class="scroll-area" :settings="settings">
        <img :src="file.source" alt="latest-upload" class="rounded mb-4 user-latest-image responsive" />
      </vue-perfect-scrollbar>
    </div>
  </vs-popup>

  <vue-perfect-scrollbar class="scroll-area" :settings="settings">
    <ul class="vx-timeline">
      <li v-for="(item,idx) in data" :key="idx" :class="['mb-0',{ 'mt-4' : isNewItem(idx) }]">
        <div class="timeline-icon"  :style="{'background-color':item.color}" v-if="isNewItem(idx)">
          <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
        </div>

        <div class="timeline-info">
          <p class="font-semibold" v-if="isNewItem(idx)">{{ item.title }}</p>
          <span class="activity-desc" v-html="item.body"></span>
        </div>



        <small class="text-grey activity-e-time">{{
              formatDate(item.created_at || new Date(), 'MM/DD/YYYY h:mm:ss')
            }}
        </small>
        <span v-if="item.file_source !== null">
          <a href="" class="activity-e-time" @click.prevent="open(item)">
            <feather-icon icon="LinkIcon" svgClasses="w-3 h-3" />
            File
          </a>
        </span>
      </li>
    </ul>
  </vue-perfect-scrollbar>
</div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import { BASE_URL } from '@/urls.js'
export default {
  components: {
    VuePerfectScrollbar,
  },
  data: () => ({
    settings: {
      maxScrollbarLength: 60,
    },
    file: {
      name:'',
      source:'',
      type:''
    },
    popupActivo: false,
  }),
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
      isNewItem(idx){

      if(idx === 0 ){
        return true
      }
      if(this.data[idx].title !== this.data[idx -1].title || this.formatDate(this.data[idx].created_at) != this.formatDate(this.data[idx -1].created_at)){
        return true
      }
    },
    open(data) {
      this.file.name = data.file_name
      this.file.source = BASE_URL + 'storage/' + data.file_source
      if(data.file_type === 'xls' || data.file_type === 'xlsx'){
        this.file.source = "https://docs.google.com/viewer?url="+this.file.source+"&embedded=true"
      }
      this.file.type = data.file_type
      this.popupActivo = true
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/components/vxTimeline.scss';

.scroll-area {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    //height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    //height: 90vh;

    &:not(.ps) {
        overflow-y: auto;
    }
}

.scroll-hiden {
    .vs-popup--content {
        overflow: hidden;
    }
}
</style>
